import utils from '@/helpers/utils';
import { useUserStore } from '@/stores/user';
import { useAppStore } from '@/stores/app';

import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { Platform, Theme, TradingType } from '@/constants';
import { useFeedLiveStore } from '@/stores/feedLive';
import { useFeedPregameStore } from '@/stores/feedPregame';
import { getPlatform } from '@/helpers/getPlatform';
import { useFeedBoardStore } from '@/stores/feedBoard';
import { globals } from '@/globals';
import { sendWhiteLableRouteChange } from '@/helpers/wl';
import { useBetStore } from '@/stores/bet';
import { useBetFailStore } from '@/stores/betFail';
import { useBotStore } from '@/stores/bot';
import { useTeamStore } from '@/stores/team';
import { useLeagueStore } from '@/stores/league';
import { useLeagueGroupStore } from '@/stores/leagueGroup';
import { useOrderStore } from '@/stores/order';
import { usePlatform } from '@/composables/usePlatform';

const platform = usePlatform();

const routes = [
    {
        path: '/',
        name: 'main',
        component: () => import('@/pages/main/MainPage.vue'),
        // component: PageMain,
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login/LoginPage.vue'),
        // component: Login
    },
    {
        path: '/init',
        name: 'init',
        component: () => import('@/pages/PageInit.vue'),
        // component: Login
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import('@/pages/registration/RegistrationPage.vue'),
    },
    {
        path: '/verify/:userId/:hash',
        alias: ['/verify/:userId/:hash/'],
        name: 'verify',
        component: () => import('@/pages/verifyEmail/PageVerifyEmail.vue'),
    },
    {
        path: '/verify-email',
        name: 'verify-email',
        component: () => import('@/pages/sendVerifyEmail/SendVerifyEmailPage.vue'),
    },
    // {
    //     path: '/event/:eventId/:tradingTypeId/:marketId',
    //     name: 'event',
    //     meta: {
    //         title: 'event',
    //         menu: 'event',
    //         breadcrumb: 'event',
    //     },
    //     component: () => import('@/pages/event/PageEvent.vue'),
    // },
    {
        path: '/dballTradingFeed',
        name: 'feedDball',
        meta: {
            title: 'pregame',
            isLive: false,
            tradingTypeId: TradingType.BetOrder,
            menu: 'markets',
            breadcrumb: 'breadcrumb_pregame',
            store: useFeedPregameStore,
        },
        component: () => import('@/pages/feed/dball/PageFeedDball.vue'),
    },
    {
        path: '/dballBotFeed',
        name: 'feedDballBot',
        meta: {
            title: 'botPregame',
            isLive: false,
            tradingTypeId: TradingType.Bot,
            menu: 'markets',
            breadcrumb: 'breadcrumb_botPregame',
            store: useFeedPregameStore,
        },
        component: () => import('@/pages/feed/dball/PageFeedDball.vue'),
    },
    {
        path: '/liveTradingFeed',
        name: 'feedLive',
        meta: {
            title: 'live',
            isLive: true,
            tradingTypeId: TradingType.BetOrder,
            menu: 'markets',
            breadcrumb: 'breadcrumb_live',
            store: useFeedLiveStore,
        },
        component: () => import('@/pages/feed/live/PageFeedLive.vue'),
        // component: feedLive
    },
    {
        path: '/liveBotFeed',
        name: 'feedLiveBot',
        meta: {
            title: 'botLiveFeed',
            isLive: true,
            tradingTypeId: TradingType.Bot,
            menu: 'markets',
            breadcrumb: 'breadcrumb_botLiveFeed',
            store: useFeedLiveStore,
        },
        component: () => import('@/pages/feed/live/PageFeedLive.vue'),
        // component: feedLive
    },
    {
        path: '/favourite',
        name: 'favourite',
        meta: {
            title: 'favourite',
            tradingTypeId: TradingType.BetOrder,
            menu: 'markets',
            breadcrumb: 'breadcrumb_favourite',
            store: useFeedBoardStore,
        },
        component: () => import('@/pages/feed/board/PageBoard.vue'),
        // component: feedLive
    },
    {
        path: '/bet',
        name: 'bet',
        meta: {
            title: 'bets',
            menu: 'trading',
            breadcrumb: 'bets',
            store: useBetStore,
        },
        component: () => import('@/pages/bet/BetPage.vue'),
        // component: Bet
    },
    {
        path: '/betFail',
        name: 'betFail',
        meta: {
            title: 'errorLog',
            menu: 'trading',
            breadcrumb: 'errorLog',
            store: useBetFailStore,
        },
        component: () => import('@/pages/betFail/PageBetFail.vue'),
        // component: BetFail
    },
    {
        path: '/bot',
        name: 'bot',
        meta: {
            title: 'bots',
            menu: 'tools',
            breadcrumb: 'botManagement',
            store: useBotStore,
        },
        component: () => import('@/pages/bot/BotPage.vue'),
        // component: Bot
    },
    {
        path: '/team',
        name: 'team',
        meta: {
            title: 'teams',
            menu: 'tools',
            breadcrumb: 'teams',
            store: useTeamStore,
        },
        component: () => import('@/pages/team/TeamPage.vue'),
        // component: League
    },
    {
        path: '/league',
        name: 'league',
        meta: {
            title: 'leagues',
            menu: 'tools',
            breadcrumb: 'leagues',
            store: useLeagueStore,
        },
        component: () => import('@/pages/league/LeaguePage.vue'),
        // component: League
    },
    {
        path: '/leagueGroup',
        name: 'leagueGroup',
        meta: {
            title: 'leagueGroups',
            menu: 'tools',
            breadcrumb: 'leagueGroups',
            store: useLeagueGroupStore,
        },
        component: () => import('@/pages/leagueGroup/LeagueGroupPage.vue'),
        // component: LeagueGroup
    },
    {
        path: '/order',
        name: 'order',
        meta: {
            title: 'orders',
            menu: 'trading',
            breadcrumb: 'orders',
            store: useOrderStore,
        },
        component: () => import('@/pages/order/OrderPage.vue'),
        // component: League
    },
    {
        path: '/rules',
        name: 'rules',
        component: () => import('@/pages/static/wl/rules/PageRules.vue'),
        // component: PageRules
    },
    {
        path: '/terms-conditions',
        name: 'terms-conditions',
        component: () => (platform.isAggregator() ? import('@/pages/static/tb/PageTermsConditions.vue') : import('@/pages/static/wl/terms/PageTermsConditions.vue')),
        // component: TermsConditions
    },
    {
        path: '/guide',
        name: 'guide',
        component: () => (platform.isAggregator() ? import('@/pages/static/tb/PageGuide.vue') : import('@/pages/static/wl/guide/PageGuide.vue')),
        // component: Guide
    },
    {
        path: '/responsible-gambling',
        name: 'responsible-gambling',
        component: () => import('@/pages/static/wl/responsibleGambling/PageResponsibleGambling.vue'),
        // component: Guide
    },
    {
        path: '/how-to-place-bet',
        name: 'how-to-place-bet',
        component: () => import('@/pages/static/wl/howToPlaceBet/PageHowToPlaceBet.vue'),
        // component: PageRules
    },
    {
        path: '/cookies-policy',
        name: 'cookies-policy',
        component: () => import('@/pages/static/wl/cookiesPolicy/PageCookiesPolicy.vue'),
        meta: {
            isHideCookiesPolicy: true,
        },
        // component: PageCookiesPolicy
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/pages/forgotPassword/ForgotPasswordPage.vue'),
        // component: ForgotPassword
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: () => import('@/pages/resetPassword/ResetPasswordPage.vue'),
        // component: ResetPassword
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('@/pages/notification/NotificationPage.vue'),
        meta: {},
        // component: Notification
    },
    {
        path: '/*',
        redirect: '/feedLive',
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

globals.router = router;

function hasQueryParams(route: RouteLocationNormalized): boolean {
    return !!Object.keys(route.query).length;
}

router.onError((err) => {
    console.error('Vue Router Error:', err);
});

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const userStore = useUserStore();
    const appStore = useAppStore();

    const exist = to.matched.length > 0;

    if (!exist) {
        return next({ name: 'feedLive' });
    }

    if (to.name === 'init') {
        next();
        return;
    }

    console.log('route to ' + to.path);
    if (
        to.name === 'login' ||
        to.name === 'registration' ||
        to.name === 'verify' ||
        to.name === 'verify-email' ||
        to.name === 'reset-password' ||
        to.name === 'forgot-password' ||
        to.name === 'main'
    ) {
        if (userStore.isLoggedIn()) {
            next({ name: 'feedLive' });
            return;
        }

        //these pages always in Light theme
        if (appStore.currentTheme !== Theme.Light) appStore.currentTheme = Theme.Light;

        if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ name: to.name, query: from.query });
        } else {
            next();
        }

        return;
    }

    if (!userStore.isLoggedIn() && to.name !== 'terms' && to.name !== 'guide' && getPlatform() === Platform.Tradeball) {
        next({ name: 'login' });
        return;
    }

    if (localStorage.getItem('isDark') !== null) {
        appStore.currentTheme = localStorage.getItem('isDark') === 'true' ? Theme.Dark : Theme.Light;
    }

    if (getPlatform() !== Platform.Tradeball) {
        sendWhiteLableRouteChange(to);
    }

    utils.updateBreadcrumbs(to.name);
    next();
});

// router.afterEach(() => {
//     if (vm.$socket && vm.$socket.readyState) {
//         let data = { pageUrl: window.location.toString() };
//
//         store.dispatch('sendObj', {
//             event: 'updateUserData',
//             data: data,
//         });
//
//         // vm.$socket.sendObj({
//         //     event: 'updateUserData',
//         //     data: data,
//         // });
//     }
// });

export default router;
